import React from 'react';
import { X } from 'lucide-react';
import { Button } from './button';

interface AllergyBadgeProps {
  medication: string;
  onRemove: () => void;
  className?: string;
}

const AllergyBadge: React.FC<AllergyBadgeProps> = ({ 
  medication, 
  onRemove, 
  className = '' 
}) => {
  return (
    <div className={`inline-flex items-center gap-1 px-3 py-1 bg-red-100 text-red-800 rounded-full text-sm font-medium ${className}`}>
      <span>{medication}</span>
      <Button
        type="button"
        size="sm"
        variant="ghost"
        onClick={onRemove}
        className="h-4 w-4 p-0 hover:bg-red-200 rounded-full"
      >
        <X className="h-3 w-3" />
      </Button>
    </div>
  );
};

export default AllergyBadge;